import React from "react";
import styled from "styled-components";

const IconStyle = styled.img`
  position: absolute;
  z-index: 99;
  margin-top: 1.8rem;
  margin-left: 1.8rem;

  @media (max-width: 1024px) {
    margin-top: 1.4rem;
    margin-left: 1.3rem;
  }

  @media (max-width: 768px) {
    margin-top: 0.8rem;
    margin-left: 0.8rem;
  }

  @media (max-width: 456px) {
    margin-top: 1.8rem;
    margin-left: 0.8rem;
  }
`;

const CircleStyle = styled.svg`
  position: relative;
  width: 96px;
  margin-bottom: 32px;

  @media (max-width: 1024px) {
    width: 80px;
    margin-bottom: 24px;
  }

  @media (max-width: 768px) {
    width: 64px;
    margin-bottom: 16px;
  }

  @media (max-width: 456px) {
    margin-top: 1rem;
  }
`;

interface Props {
  icon?: string;
  circleColor?: string;
}

const Circle: React.FC<Props> = ({ icon, circleColor }) => {
  return (
    <div>
      <IconStyle src={icon} alt="icon" width="40" height="40" />
      <CircleStyle
        viewBox="0 0 100 100"
        fill={circleColor ? circleColor : "#1D2F5D"}
      >
        <circle cx="50" cy="50" r="50" />
      </CircleStyle>
    </div>
  );
};

export default Circle;
